import { useEffect } from 'react';

const SUFFIX = 'Xtremand';

/**
 * Names the page.
 *
 * <h2>Why every route needs one</h2>
 *
 * The title is what a browser tab shows, what a bookmark is saved as, what
 * appears in history, and what a screen reader announces on navigation. A
 * single-page application sets it once in `index.html` and then never again — so
 * every page is called "Xtremand", eleven identical tabs are indistinguishable,
 * and {@link RouteAnnouncer} has nothing useful to announce.
 *
 * <p>It is restored on unmount so a route that sets one cannot leave its title
 * behind on whatever renders next.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;

    return () => {
      document.title = previous;
    };
  }, [title]);
}
